// Thin wrapper around the legacy d3 v3 layout, bundled as a module (aytmTextCollisions.js
// + the module-scoped d3 v3 in app/stats/components/topography) — no window globals.
//
// Why not port:
//   1) Zero risk of subtle bugs — literally the same code that coffee uses
//   2) d3.geom.quadtree (v3 API) is not available in npm d3 v7 — porting would require rewriting from scratch
//   3) Easy to compare behavior with coffee when debugging (identical)

import { aytmTextCollisions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/aytmTextCollisions'

/**
 * Creates an instance of aytm text-collision layout.
 * API: .size(w, h).setCirclePadding(n).setAngleStep(deg).run(points)
 *
 * points: [
 *   { id, circle: {x, y, r}, label: {text, w, h} },  // for labels
 *   { id, line: {x1, y1, x2, y2} }                    // for axes
 * ]
 * returns: { [id]: { x, y, text } }
 */
export const createTextCollisions = () => aytmTextCollisions()
